import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { catalog } from '../content'
import { media } from '../content/media'
import { useManualLocale } from '../i18n/LocaleContext'
import { manualUi } from '../i18n/messages'
import { manualPagePath } from '../paths'

export function HomePage() {
  const { locale } = useManualLocale()
  const ui = manualUi(locale)
  const navigation = catalog(locale).navigation

  useEffect(() => {
    document.title = ui.documentTitle
  }, [ui.documentTitle])

  return (
    <div className="home">
      <section className="home-hero">
        <div className="home-hero-copy">
          <p className="brand-line hero-brand">
            <span className="brand-sepm">SEPM</span>
            <span className="brand-sep">·</span>
            <span className="brand-product">X-Translator</span>
          </p>
          <h1>{ui.manual}</h1>
          <p className="hero-lead">{ui.heroLead}</p>
          <div className="hero-actions">
            <Link className="btn btn-primary" to={manualPagePath('getting-started')}>
              {ui.startHere}
            </Link>
            <Link className="btn btn-ghost" to={manualPagePath('formats')}>
              {ui.browseFormats}
            </Link>
          </div>
        </div>
        <div className="home-hero-visual">
          <img src={media.sepmLogo} alt={ui.logoAlt} />
        </div>
      </section>

      <section className="home-highlights" aria-label={ui.popularTopics}>
        {ui.highlights.map((item) => (
          <Link key={item.to} to={manualPagePath(item.to)} className="highlight-link">
            <h2>{item.title}</h2>
            <p>{item.text}</p>
          </Link>
        ))}
      </section>

      <section className="home-catalog">
        <h2>{ui.allChapters}</h2>
        <div className="catalog-grid">
          {navigation.map((category) => (
            <div key={category.id} className="catalog-group">
              <h3>{category.title}</h3>
              <ul>
                {category.pages.map((page) => (
                  <li key={page.id}>
                    <Link to={manualPagePath(page.id)}>{page.title}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>
    </div>
  )
}
